import { Component } from 'react';
import { connect } from 'react-redux';
import { validator } from 'Helpers/validator';
import { Link } from 'react-router-dom';
import Loginbg from './images/login-wallpaper.svg';
import loginlogo from 'assets/images/logo.svg';
import yabsyslogo from 'assets/images/DAZAPP-Logo.svg';
import yabsystext from 'assets/images/Daz App.svg';
import loginbanner from 'assets/images/login-banner.svg';
import { ReactComponent as Close } from 'assets/images/svg/Popclose.svg';
import LoadingOverlay from 'react-loading-overlay';
import labeltop from 'Helpers/labelTop';
import EyeIcon from 'Components/Common/eyeIcon';
import { ReactComponent as Triangle } from 'assets/images/svg/triangle.svg';
import { ReactComponent as Square } from 'assets/images/svg/square.svg';
import { ReactComponent as Bubble } from 'assets/images/svg/bubble.svg';
import validation from 'Helpers/Validation';
import { AUTO_LOGOUT_MESSAGE } from 'Helpers/apiurl';
import { decryptUserToken } from 'Helpers/';
import routesPath from 'Constants/routes.constants';
import Lottie from 'react-lottie-player';
import lottieJson from 'assets/js/animation.json';

/**
 * @file LoginPage Component
 * User authentication
 * @module 1.LoginPage
 * @extends Component
 */
class LoginPage extends Component {
  constructor(props) {
    super(props);
    this.state = {
      username: '',
      password: '',
      showPassword: false,
      autoLogout: false,
    };
    this.validator = validator.getInstance();
  }

  /**
   * @method handleChange
   * @summary set the username and password state
   * @param {event} event - React onChange event
   * @return {none} undefined
   */
  handleChange = e => {
    const { name, value } = e.target;
    this.setState({ [ name ]: value });
  };

  /**
   * @method validation
   * @summary validate the inputs based on validation rules
   * @param {event} event - React onBlur event
   * @return {none} undefined
   */
  validation = e => {
    validation(e, 'login-form');
  };

  togglPasswordIcon = event => {
    event.preventDefault();
    const { showPassword } = this.state;

    this.setState({ showPassword: !showPassword });
  };

  componentDidMount() {
    const user = decryptUserToken()
    if (user && user !== 'undefined') {
      this.props.history.push(routesPath.root)
      return;
    }else {
      this.setState({
        autoLogout: this.props.autoLogout ? true : false,
      })
    }
  }

  handleAutoLogout = () => {
    this.setState({
      autoLogout: false,
    })
  }

  componentDidUpdate(prevProps) {
    if (this.props.errorElement !== prevProps.errorElement) {
      this.setState({ errorElement: this.props.errorElement });
    }
  }

  /**
   * @method handleSubmit
   * @summary submit the login form after the validation
   * @param {event} event - React onSubmit event
   * @return {none} undefined
   */
  handleSubmit = event => {
    event.preventDefault();
    const formId = event.target.id;
    this.setState({ errorElement: null }, () => {
      const { username, password } = this.state;
      if (formId && !this.validator.checkBeforeSubmit(formId)) {
        this.props.login(username, password);
      }
    });
  };

  render() {
    const { username, password, showPassword, errorElement, autoLogout } = this.state;
    const { loading, message } = this.props;
    return (
      <div className='main-logindiv' id='login-page'>
        <div className="loginPage">
          <div className="loginPage__left">
          {/* <Lottie
            loop={ true }
            animationData={ lottieJson }
            play={ true }
            speed={ 1 }
            className="lottie"
          /> */}

          <img src={ loginbanner } alt="login-banner" width="470"/>
          </div>

          <div className="loginPage__right">
            <div className="loginPage__right--form">
              <div className='logo-container'>
                <img className="logo" src={ yabsyslogo } alt="Logo" width="80" />
                <img className="logo" src={ yabsystext } alt="Logo" width="90" />
              </div>       
              <form              
                id='login-form'
                className='login-form'
                autoComplete='off'
                onSubmit={ this.handleSubmit }
              >
                <div className="form-group">
                  <label className="login-label">E-Mail Address</label>
                  <input
                    id='test'
                    className='form-control input-lg'
                    onBlur={ this.validation }
                    readOnly
                    data-validation={ [ 'usernameoremail' ] }
                    onChange={ this.handleChange }
                    onFocus={ labeltop }
                    value={ username }
                    type='text'
                    name='username'
                  />
                </div>

                <div className="form-group position-relative">
                  <label className="login-label">Password</label>
                  <input
                      className='form-control input-lg'
                      onBlur={ this.validation }
                      readOnly
                      data-validation={ [ 'passwordPattern' ] }
                      onChange={ this.handleChange }
                      onFocus={ labeltop }
                      value={ password }
                      type={ showPassword ? 'text' : 'password' }
                      name='password'
                    />
                    <EyeIcon className="input-icon input-icon-lg"
                        dispatchFunction={ this.togglPasswordIcon }
                        showPassword={ showPassword }
                      />
                </div>

                <Link to='/forgotPassword' className="login-link">Forgot Password?</Link>
                <button type="submit" className="btn btn_primary submitBtn" >Sign In</button>

              </form>
            </div>
          </div>
        </div>
        <LoadingOverlay
          spinner
          active={ loading }
          text='Please wait...'
          styles={ {
            wrapper: {
              width: '100%',
              textAlign: '-webkit-center'
            }
          } }
        >
        </LoadingOverlay>
        {autoLogout &&
          <div className='profile-container delete-image'>
            <div className='profile-popup-visible'>
              <div className='popup-controls'>
                <i className='popup_close' onClick={ () => this.handleAutoLogout() }><Close/></i>
                <div className='popup-body'>
                  { AUTO_LOGOUT_MESSAGE }
                  <div className='buttons'>
                    <a class="btn btn_primary" onClick={ () => this.handleAutoLogout() }>Ok</a>
                  </div>
                </div>
              </div>
            </div>
          </div>
        }
      </div>
    );
  }
}

function mapStatetoProps(state){
  const { autoLogout } = state.userlogout;
  return {
    autoLogout,
  }
}

export default connect(mapStatetoProps)(LoginPage);
